import { debounce } from "underscore";


export class NavigationLivePane {
    ESC_keyCode = 27;

    events = {
        open: 'open-lives',
        close: 'close-lives'
    };

    overlayTPL = '<div class="navigation-live__overlay" />';

    // staff
    window = $(window);
    body;
    header;
    pane;
    button;

    constructor() {
        this.onInit();
    };

    onInit() {
        // Lo desactivamos conservando el código por ahora
        return; // Quitar run para activar.
        this.header = $('#header');
        this.pane = $('.navigation-live-pane');
        this.button = $('.live-lnk');
        this.body = $('body');
        this.overlay = $(this.overlayTPL).appendTo(this.body);

        if (!this.pane.length || !this.button.length) {
            return;
        }

        this.bindEvents();
    }

    bindEvents() {
        this.window
            .on(this.events.close, (e) => this.onClose(e))
            .on(this.events.open, (e) => this.onOpen(e))
            .resize(debounce(() => {
                this.updateTop();
                this.updateHeight();
            }, 16))
            .keyup((e) => this.onKeyup(e));

        this.button.click((e) => this.onClick(e));
        this.overlay.click((e) => this.onClick(e));
    };

    // Events
    onClick(e) {
        e.preventDefault();

        if (this.isActive()) {
            this.window.trigger(this.events.close);
        } else {
            this.window.trigger(this.events.open);
        }
    }

    onClose(e) {
        e.preventDefault();

        this.button.removeClass('navigation-live-button--active');
        this.pane.removeClass('navigation-live-pane--active');
        this.body.removeClass('navigation-live--active');
        this.overlay.removeClass('navigation-live__overlay--active');
    };

    onOpen(e) {
        e.preventDefault();

        this.updateTop();
        this.updateHeight();

        this.button.addClass('navigation-live-button--active');
        this.pane.addClass('navigation-live-pane--active');
        this.body.addClass('navigation-live--active');
        this.overlay.addClass('navigation-live__overlay--active');
    };

    onKeyup(e) {
        e.preventDefault();

        if (e.keyCode !== this.ESC_keyCode) {
            return;
        }

        this.window.trigger(this.events.close);
    }

    // Functions
    updateTop() {
        const offsetTop = this.header.find('.masthead').outerHeight();
        let scrollTop = $(window).scrollTop();
        let elementOffset = this.header.find('.masthead').offset().top;
        let distance = (offsetTop + elementOffset) - scrollTop;

        this.pane.css('top', distance);
    }

    updateHeight() {
        // Hacemos esto en caso de que haya muchos directos.
        const numLives = 3;
        const numChilds = this.pane.children().length;

        if (numChilds >= numLives) {
            this.pane.css('height', 'auto');
        }
    }

    isActive() {
        return this.pane.is('.navigation-live-pane--active');
    }
}
